import React from 'react';
import ToggleThemeBtn from './shared/ToggleThemeBtn';
import User from './shared/User';

const Header = () => {
  return (
    <div id="page-header" className="header">
      <div className="header_left">
        <div className="header_logo">
          <a href="https://docs.silabs.com">
            <img
              className="header_img"
              src="/assets/images/logo.svg"
              alt="Silabs Logo"
            />
          </a>
        </div>
        <div className="header_title">
          <div>Developer Documentation</div>
        </div>
      </div>
      <div className="header_tabs">
        <ul className="tab_list">
          <li className="tab_items">
            <a className="header_tab" href="/" target="_blank">
              Home
            </a>
          </li>
          <li className="tab_items">
            <a
              className="header_tab"
              href="https://www.silabs.com/support/training"
              target="_blank"
              rel="noreferrer"
            >
              Training
            </a>
          </li>
          <li className="tab_items">
            <a
              className="header_tab"
              href="https://www.silabs.com/support"
              target="_blank"
              rel="noreferrer"
            >
              Support
            </a>
          </li>
          <li className="tab_items github_tab">
            <a
              className="header_tab"
              href="https://github.com/SiliconLabs"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
          </li>
        </ul>
      </div>
      <div className="header_right">
        <ul className="tab_list">
          <li className="tab_items">
            <ToggleThemeBtn />
          </li>
          <li className="tab_items tab_items_user">
            <User />
          </li>
          <li className="tab_items kapa-open" data-test-id="header-search">
            <img
              src="/assets/images/icons/icon-ionic-ios-search.svg"
              alt="Silabs Search"
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
